import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import ProdutoEstoqueController from "@/shared/controllers/produtoEstoque/produtoEstoqueController"
import FiltroProdutoEstoque from "@/shared/view-models/Filtros/FiltroProdutoEstoque";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import FilialController from "@/shared/controllers/filial/filialController";
import PedidoController from "@/shared/controllers/pedido/PedidoController";

const name = 'ProdutosEstoque'
export default {
  name,

  components: {
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-form': gForm
  },

  props: { },
  watch: {
    objFiltros() {
      if (this.objFiltros.ClienteId == (undefined || null))
      {
        this.ClienteAgrupadorAtiva = true;
      }
     }
  },
  mounted () {
    this.UnidadeArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
    this.popularDropDownEmpresa();
    this.atualizaEmpresaRepresentante();
    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })
    this.FilialArray = FilialController.GetFiliaisAtivas().FilialArray;
    this.StatusArray = PedidoController.GetStatusPedidoEnum().StatusArray;
    this.TipoProdutoEstoqueArray = ProdutoEstoqueController.GetTipoProdutoEstoqueEnum().TipoProdutoEstoqueArray;
    this.SegmentoProdutoEstoqueArray = ProdutoEstoqueController.GetSegmentoProdutoEstoqueEnum().SegmentoProdutoEstoqueArray;
    },

  updated () { },

  data () {
    return {
      // somaValorUnitarioCaixa: null,
      // somaQuantidadeFolhas: null,
      // somaQuantidadeCaixas: null,
      ProdutoArray: [],
      ClienteArray: [],
      UnidadeArray: [],
      FilialArray: [],
      StatusArray: [],
      EmpresaArray: [],
      totalTeste:1000,
      TipoProdutoEstoqueArray: [],
      ClienteAgrupador: [],
      SegmentoProdutoEstoqueArray: [],
      checkboxConsultas: null,
      pt1: true,
      ClienteAgrupadorAtiva: true,
      ProdutosEstoqueArray: [],
      objFiltros: new FiltroProdutoEstoque(),
      Colunas : [
        {field: 'campoProduto_ProdutoEstoque', header: 'Produto',width: '350px', ordena: true},
        {field: 'diasEmEstoque', header: 'Dias Estoque', ordena: true, alinha: 'right'},
        {field: 'quantidadeCaixasFormatada', header: 'Qtde Caixas', ordena: true, alinha: 'right'},
        {field: 'quantidadeFolhasFormatada', header: 'Qtde Folhas', ordena: true, alinha: 'right'},
        {field: 'valorTotalFormatado', header: 'Valor', ordena: true, alinha: 'right'},
        {field: 'tipoProdutoEstoqueTexto', header: 'Tipo', ordena: true, alinha: 'center'},
        {field: 'liquidadoTexto', header: 'Liquidado', ordena: true, alinha: 'center'},
      ],

      Colunas2 : [],
    }
  },

  methods: {
    getProduto(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(pesquisa, this.$store.state.representanteSelecionadoId, this.objFiltros.UnidadeId).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },
    Grid() {
      this.AllProdutosEmEstoque()
    },
    ativaClienteAgrupador() {
      this.ClienteAgrupadorAtiva = false;
    },
    AllProdutosEmEstoque() {
  
      this.$isLoading(true)
      ProdutoEstoqueController.AllProdutosEmEstoque(this.objFiltros).requisicao
      .then(response => {
        this.pt1 = false
        this.ProdutosEstoqueArray = response.data.data || []
        // if(this.objFiltros.ConsultarDadosClienteAgrupador == true){
        //   for(i = 0; i <= this.ClienteAgrupador.lenght; i++) 
        //   {
        //     if(this.ClienteAgrupador.id != this.ProdutosEstoqueArray.id) {
        //         this.ClienteAgrupador.forEach((Element) => this.ProdutosEstoqueArray.push(Element))
        //     }
        //   }
        // }

      })
      .finally(() => {
        this.$isLoading(false)
      })
    },
    // GetClienteAgrupador() {

    //   this.$isLoading(true)
    //   ProdutoEstoqueController.GetClienteAgrupador(this.objFiltros).requisicao
    //   .then(response => {
    //     this.ClienteAgrupador = response.data.data
    
    //     var i = 0;
    //     for(i = 0; i <= this.ClienteAgrupador.lenght; i++) 
    //     {
    //       if(this.ClienteAgrupador.id != this.ProdutosEstoqueArray.id) {
    //           this.ClienteAgrupador.forEach((Element) => this.ProdutosEstoqueArray.push(Element))
    //       }
    //     }
       
    //   })
    //   .finally(() => {
    //     this.$isLoading(false)
    //   })
    // },

    atualizaEmpresaRepresentante() {
      this.objFiltros.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClienteArray = ClienteController.GetAllClientesByEmpresaIdEFiltro(this.objFiltros.UnidadeId,event).ClientesArray;
      }, 1000);
    },

    limpar(){
      this.objFiltros = new FiltroProdutoEstoque();
      this.ClienteArray = []
      EmpresaController.getEmpresasAtivas().requisicao
      .then(response => {
        this.UnidadeArray = response.data.data
        this.atualizaEmpresaRepresentante()
      })
      this.mitt.on('trocaEmpresaRepresentante', () => {
        this.atualizaEmpresaRepresentante()
      })
    },

    detalhesProdutoEstoque(data){
      const rotaNovaAbaURL = this.$router.resolve({
        path: `produtos-informacao/${data.id}/${data.numeroParcela}`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    },
    
    popularDropDownEmpresa(){
      this.EmpresaArray = this.$store.state.EmpresaArray;
      this.atualizaEmpresaRepresentante()
      },
  },

  computed: { },

};